<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'basic-data-modal.custom-concept-properties'">_Propiedades del concepto personalizado</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content-scroll">
    <div class="common-modal__form-container-extend">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-text-simple [field]="basicDataModal.nameInfo"
        [preSelectItem]="basicDataModal.conceptData.title"
        (itemSelected)="itemSelected($event, 'title')">
      </field-type-text-simple>
      <field-type-rich-text-editable
        [field]="basicDataModal.descriptionField"
        [preSelectItem]="basicDataModal.conceptData.description"
        (itemSelected)="getEditorValue($event)">
      </field-type-rich-text-editable>
      <div class="basic-data-modal__switches-container">
        <div class="common-switch__col-container">
          <field-type-switch [field]="{label: 'common.public-dissemination'|afTranslate}"
            [small]="true"
            [preSelectItem]="basicDataModal.conceptData.allowPublicShare"
            [disabled]="basicDataModal.disabledConcept || concept.hasInstances || concept.publicShared"
            (itemSelected)="restore('allowPublicShare', $event.newValue)">
          </field-type-switch>
          @if (basicDataModal.conceptData.allowPublicShare) {
            <field-type-switch [field]="{label: 'common.communication-channel'|afTranslate}"
              [small]="true"
              [preSelectItem]="basicDataModal.conceptData.communicationChannel"
              [disabled]="concept.publicShared || concept.hasArchivedInstances"
              (itemSelected)="communicationChannel()">
            </field-type-switch>
            <field-type-switch [field]="{label: 'common.locked-edit'|afTranslate}"
              [small]="true"
              [preSelectItem]="basicDataModal.conceptData.lockedEdit"
              [disabled]="basicDataModal.conceptData.communicationChannel || concept.publicShared || concept.hasArchivedInstances"
              (itemSelected)="basicDataModal.conceptData.lockedEdit = $event.newValue">
            </field-type-switch>
            <field-type-switch [field]="{label: 'common.restricted-delete-switch'|afTranslate}"
              [small]="true"
              [preSelectItem]="basicDataModal.conceptData.restrictedDelete"
              [disabled]="basicDataModal.conceptData.communicationChannel || concept.publicShared || concept.hasArchivedInstances"
              (itemSelected)="basicDataModal.conceptData.restrictedDelete = $event.newValue">
            </field-type-switch>
          }
        </div>
        <field-type-switch [field]="{label: 'common.group-as-list'|afTranslate}"
          [small]="true"
          [preSelectItem]="basicDataModal.conceptData.groupsAsList"
          [disabled]="basicDataModal.conceptData.sequentialView || basicDataModal.disabledPoll || concept.hasInstances || concept.publicShared"
          (itemSelected)="restore('groupsAsList', $event.newValue)">
        </field-type-switch>
        <div class="common-switch__col-container">
          <field-type-switch [field]="{label: 'basic-data-modal.survey-design'|afTranslate}"
            [small]="true"
            [preSelectItem]="basicDataModal.conceptData.poll"
            [disabled]="basicDataModal.disabledPoll || basicDataModal.sharedPoll || basicDataModal.noEditablePoll || concept.hasInstances || concept.publicShared"
            (itemSelected)="restore('poll', $event.newValue)">
          </field-type-switch>
          @if (basicDataModal.conceptData.poll) {
            <field-type-switch [field]="{label: 'basic-data-modal.public-access'|afTranslate}"
              [small]="true"
              [preSelectItem]="basicDataModal.conceptData.anonymousAccess"
              [disabled]="basicDataModal.disabledPoll || concept.publicShared"
              (itemSelected)="basicDataModal.conceptData.anonymousAccess = $event.newValue">
            </field-type-switch>
            <field-type-switch [field]="{label: 'basic-data-modal.view-fields'|afTranslate}"
              [small]="true"
              [preSelectItem]="basicDataModal.conceptData.sequentialView"
              [disabled]="basicDataModal.disabledPoll || concept.publicShared"
              (itemSelected)="restore('sequentialView', $event.newValue)">
            </field-type-switch>
          }
        </div>
      </div>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    @if (basicDataModal.disabledAcceptButton) {
      <button class="common-button__text"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.close'">_Cerrar</span>
      </button>
    }@else{
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      <button class="common-button__text"
        (click)="validateFields()">
        <span class="common-button__text-title"
          [afTranslate]="type === 'edit'?'common.save':'common.create'">_Crear/Guardar</span>
      </button>
    }
  </div>
</div>
